import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  deletePaymentByIdAPIHandler,
  downloadPaymentFile,
  getPaymentList,
} from "../../../../services/api_services/PaymentService";
import {
  convertDateAndTimeToString,
  downloadFileFromURL,
  getSelectedBranchId,
  searchResult,
} from "../../../../utils/HelperFunctions";
import SectionLoader from "../../../../components/global/loader/SectionLoader";
import {
  EnhancedTableHead,
  getComparator,
  stableSort,
} from "../../../../components/dashboard/table_component/TableComponent";
import Button from "../../../../components/global/button/Button";
import {
  ROLE_ASSISTANT,
  ROLE_FRONT_DESK_ADMIN,
  SEARCH_RESULT_FOR_PAYMENTS,
} from "../../../../utils/Constants";
import GlobalData from "../../../../utils/GlobalData";
import { toast } from "react-toastify";
import SelectInstructionModal from "../../../../modals/contact/SelectInstructionModal.js";
import { paymentId, setPaymentId } from "../../contacts/tabs/DocProWallet.js";
import "./css/payments.css";

export default function PaymentTab() {
  const userRole = JSON.parse(sessionStorage.getItem("UserRole"));
  const orgDetails = JSON.parse(sessionStorage.getItem("OrgDetails"));
  const isPaymentAccessAllowed =
    orgDetails && orgDetails?.isPaymentAccessAllowed
      ? orgDetails?.isPaymentAccessAllowed
      : false;
  useEffect(() => {
    return () => {
      setPaymentId(null);
    };
  }, []);

  const headCells = [
    {
      id: "invoiceId",
      numeric: false,
      disablePadding: false,
      label: "Invoice No",
    },
    {
      id: "clientName",
      numeric: false,
      disablePadding: false,
      label: "Patient",
    },
    {
      id: "paymentType",
      numeric: false,
      disablePadding: false,
      label: "Payment Type",
    },
    {
      id: "paymentDate",
      numeric: false,
      disablePadding: false,
      label: "Paid Date",
    },
    {
      id: "amount",
      numeric: true,
      disablePadding: false,
      label: "Amount",
    },

    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
    },
  ];

  const [loading, setLoading] = useState(false);
  const [isExportFileLoading, setIsExportFileLoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("id");
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [paymentList, setPaymentList] = useState([]);
  const [searchData, setSearchData] = useState(
    paymentId ? paymentId.toString() : "",
  );
  const [paymentTypeFilter, setPaymentTypeFilter] = useState("");
  const [fileType, setFileType] = useState("pdf");
  const [selectFileType, setSelectFileType] = useState(false);
  const [showInvoiceInstructionModal, setShowInvoiceInstructionModal] =
    useState(false);
  const [isSelectInvoiceInstructionModal, setIsSelectInvoiceInstructionModal] =
    useState(false);
  const [paymentToDownload, setPaymentToDownload] = useState("");
  const [totalPaymentCount, setTotalPaymentCount] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [shouldFetch, setShouldFetch] = useState(false);
  const [showTodaysPayments, setShowTodaysPayments] = useState();
  const [total, setTotal] = useState(0);
  const [totalCashPayment, setTotalCashPayment] = useState(0);
  const [totalUPIPayment, setTotalUPIPayment] = useState(0);
  const [totalOtherPaymentMethodsPayment, setTotalOtherPaymentMethodsPayment] =
    useState(0);
  const [totalCreditWalletPayment, setTotalCreditWalletPayment] = useState(0);
  const [showPaymentSummary, setShowPaymentSummary] = useState();
  const [visitTypeFilter, setVisitTypeFilter] = useState(["HOME", "BRANCH"]);

  async function getAllPaymentList() {
    const fromDate = dateToMillisAtMidnight(startDate);
    const toDate = dateToMillisAtEndOfDay(endDate);
    let data = JSON.stringify({
      fromDate: fromDate,
      toDate: toDate,
      type: paymentTypeFilter ? paymentTypeFilter : "",
      status: "",
      text: searchData,
      paymentId: paymentId ? paymentId : 0,
      addressId: paymentId && paymentId !== 0 ? "" : getSelectedBranchId(),
      visitType: getVisitTypeValue(),
    });
    setLoading(true);
    const response = await getPaymentList(page, rowsPerPage, data);
    if (response && response.data) {
      setPaymentList(response.data.list);
      setTotalPaymentCount(response.data.count);
      setTotal(response.data.totalPayment);
      setTotalCashPayment(response.data.totalPaymentByCash);
      setTotalUPIPayment(response.data.totalPaymentByUpi);
      setTotalOtherPaymentMethodsPayment(
        response.data.totalPaymentByOtherPaymentMethods,
      );
      setShowPaymentSummary(response.data.showPaymentSummary);
      setShowTodaysPayments(response.data.showTodaysPayments);
      setTotalCreditWalletPayment(response?.data?.totalPaymentByCreditWallet);
    } else {
      setPaymentList([]);
      setTotalPaymentCount();
    }
    setLoading(false);
  }

  useEffect(() => {
    getAllPaymentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, shouldFetch]);

  useEffect(() => {
    const handleBranchChange = () => {
      setPage(0);
      setShouldFetch((prev) => !prev);
    };

    window.addEventListener("branchChanged", handleBranchChange);

    return () => {
      window.removeEventListener("branchChanged", handleBranchChange);
    };
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowPerPage(parseInt(event.target.value, 10));
  };

  async function deletePaymentByIdHandler(id, index) {
    const confirmed = window.confirm(
      "Are you sure you want to delete this payment details?",
    );

    if (confirmed) {
      let response = await deletePaymentByIdAPIHandler(id);
      if (response) {
        getAllPaymentList();
      }
    }
  }

  async function downloadPaymentFileHandler() {
    setIsExportFileLoading(true);
    const fromDate = dateToMillisAtMidnight(startDate);
    const toDate = dateToMillisAtEndOfDay(endDate);
    let data = JSON.stringify({
      fileType: fileType,
      fromDate: fromDate,
      toDate: toDate,
      status: "",
      text: paymentId
        ? searchData === paymentId.toString()
          ? ""
          : searchData
        : searchData,
      paymentType: paymentTypeFilter,
      paymentId: paymentId ? paymentId : 0,
      selectedAddressId: getSelectedBranchId(),
      visitType: getVisitTypeValue(),
    });
    const response = await downloadPaymentFile(data);
    if (response) {
      downloadFileFromURL({
        id: response,
        fileName: `payments.${fileType}`,
      });
      setSelectFileType(false);
      setFileType("pdf");
    }
    setIsExportFileLoading(false);
  }

  function isStartDateBeforeEndDate(startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    return start <= end;
  }

  function handleSearch(e) {
    e.preventDefault();

    setErrorMessage("");

    if (startDate || endDate) {
      if (!startDate) {
        setErrorMessage("Please select start date");
        return;
      }

      if (!endDate) {
        setErrorMessage("Please select end date");
        return;
      }

      if (!isStartDateBeforeEndDate(startDate, endDate)) {
        setErrorMessage("Start date should be less than end date");
        return;
      }
    }
    getAllPaymentList();
  }

  const resetData = () => {
    setSearchData("");
    setStartDate("");
    setEndDate("");
    setPaymentTypeFilter("");
    setErrorMessage("");
    setShouldFetch(!shouldFetch);
    setPaymentId(0);
    setFileType("pdf");
    setVisitTypeFilter(["HOME", "BRANCH"]);
  };
  function dateToMillisAtMidnight(dateStr) {
    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);
    return date.getTime();
  }

  function dateToMillisAtEndOfDay(dateStr) {
    const date = new Date(dateStr);
    date.setHours(23, 59, 59, 999);
    return date.getTime();
  }

  function toggleInvoiceInstructionModal() {
    if (isSelectInvoiceInstructionModal) {
      setIsSelectInvoiceInstructionModal(false);
    }
    setShowInvoiceInstructionModal(!showInvoiceInstructionModal);
  }

  function handleExportReport() {
    if (!startDate || !endDate) {
      toast.error(
        "Please select start date and end date to export the report file.",
      );
      return;
    } else if (!isStartDateBeforeEndDate(startDate, endDate)) {
      toast.error("Start date should be less than end date");
      return;
    } else if (fileType === "") {
      toast.error("Please select file type");
      return;
    } else {
      downloadPaymentFileHandler();
    }
  }

  function getVisitTypeValue() {
    if (
      visitTypeFilter.includes("HOME") &&
      visitTypeFilter.includes("BRANCH")
    ) {
      return "ALL";
    }

    if (visitTypeFilter.includes("HOME")) {
      return "HOME";
    }

    if (visitTypeFilter.includes("BRANCH")) {
      return "BRANCH";
    }

    return null;
  }

  return (
    <div className="p-3">
      <>
        <form onSubmit={handleSearch}>
          <div className="mb-3 d-flex flex-column flex-md-row justify-content-between flex-wrap gap-3">
            <div className="form-floating col-md-3">
              <input
                type="search"
                className="form-control"
                id="floatingInput"
                placeholder="Search by Invoice No, Name"
                value={searchData}
                onChange={(e) => {
                  setPage(0);
                  setSearchData(e.target.value);
                }}
              />
              <label htmlFor="floatingInput">Search by Invoice No, Name</label>
            </div>

            <div className="col-12 col-md-4 col-lg-4">
              <div className="d-flex gap-2 flex-md-row">
                <div className="form-floating col-6">
                  <input
                    type="date"
                    className="form-control"
                    id="startDate"
                    placeholder=""
                    onChange={(event) => setStartDate(event.target.value)}
                  />
                  <label htmlFor="startDate">From</label>
                </div>
                <div className="form-floating col-6">
                  <input
                    type="date"
                    className="form-control"
                    id="endDate"
                    placeholder=""
                    onChange={(event) => setEndDate(event.target.value)}
                  />
                  <label htmlFor="endDate">To</label>
                </div>
              </div>
              <p className="mt-1 txt-error">{errorMessage}</p>
            </div>
            <div className="form-floating col-12 col-md-4 col-lg-2 ">
              <select
                className="form-select"
                id="selectPaymentType"
                aria-label="Payment Type"
                value={paymentTypeFilter}
                onChange={(e) => {
                  setPaymentTypeFilter(e.target.value);
                }}
              >
                <option value="">All</option>
                {[...GlobalData.PAYMENT_TYPE, "Credit Wallet"]
                  .sort((a, b) => a.localeCompare(b))
                  .map((type, index) => {
                    return (
                      <option key={`${index}`} value={type}>
                        {type}
                      </option>
                    );
                  })}
              </select>
              <label htmlFor="selectPaymentType">Payment Type</label>
            </div>
            <div className="mt-2">
              <label className="form-label mb-1">Serviced at</label>

              <div className="d-flex gap-3 flex-wrap">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="homeVisit"
                    checked={visitTypeFilter.includes("HOME")}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setVisitTypeFilter((prev) => [...prev, "HOME"]);
                      } else {
                        setVisitTypeFilter((prev) =>
                          prev.filter((type) => type !== "HOME"),
                        );
                      }
                    }}
                    disabled={isExportFileLoading}
                  />
                  <label className="form-check-label" htmlFor="homeVisit">
                    Home
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="branchVisit"
                    checked={visitTypeFilter.includes("BRANCH")}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setVisitTypeFilter((prev) => [...prev, "BRANCH"]);
                      } else {
                        setVisitTypeFilter((prev) =>
                          prev.filter((type) => type !== "BRANCH"),
                        );
                      }
                    }}
                    disabled={isExportFileLoading}
                  />
                  <label className="form-check-label" htmlFor="branchVisit">
                    Branch
                  </label>
                </div>
              </div>
            </div>
            <div>
              <Button className="mt-2 me-2" onClick={() => {}}>
                Filter
              </Button>
              <Button className="outline" type="reset" onClick={resetData}>
                Reset
              </Button>

              {userRole &&
              userRole != null &&
              (userRole === ROLE_FRONT_DESK_ADMIN ||
                userRole === ROLE_ASSISTANT) ? (
                isPaymentAccessAllowed && (
                  <div>
                    <button
                      className="txt-primary bg-transparent border-0 mt-2"
                      style={{ fontSize: "15px" }}
                      type="button"
                      onClick={() => setSelectFileType(!selectFileType)}
                    >
                      <i className="bi bi-file-earmark-arrow-down" /> Export
                      Payments
                    </button>
                    {selectFileType && (
                      <>
                        <div className="d-flex flex gap-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="csvFileType"
                              checked={fileType === "csv" ? true : false}
                              name="fileType"
                              value="csv"
                              onChange={() => setFileType("csv")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="csvFileType"
                            >
                              CSV file
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="pdfFileType"
                              name="fileType"
                              value="pdf"
                              checked={fileType === "pdf" ? true : false}
                              onChange={() => setFileType("pdf")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="pdfFileType"
                            >
                              Pdf File
                            </label>
                          </div>

                          <Button
                            className="small outline"
                            type="button"
                            isLoading={isExportFileLoading}
                            disabled={isExportFileLoading}
                            onClick={() => {
                              handleExportReport();
                            }}
                            buttonTitle={
                              isExportFileLoading ? "Exporting..." : "Export"
                            }
                          ></Button>
                          <Button
                            className="error small outline"
                            disabled={isExportFileLoading}
                            type="button"
                            title="Close"
                            onClick={() => {
                              setFileType("pdf");
                              setSelectFileType(!selectFileType);
                            }}
                          >
                            <i className="bi bi-x-lg"></i>
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                )
              ) : (
                <>
                  <div>
                    <button
                      className="txt-primary bg-transparent border-0 mt-2"
                      style={{ fontSize: "15px" }}
                      type="button"
                      onClick={() => setSelectFileType(!selectFileType)}
                    >
                      <i className="bi bi-file-earmark-arrow-down" /> Export
                      Payments
                    </button>
                    {selectFileType && (
                      <>
                        <div className="d-flex flex gap-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="csvFileType"
                              checked={fileType === "csv" ? true : false}
                              name="fileType"
                              value="csv"
                              onChange={() => setFileType("csv")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="csvFileType"
                            >
                              CSV file
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="pdfFileType"
                              name="fileType"
                              value="pdf"
                              checked={fileType === "pdf" ? true : false}
                              onChange={() => setFileType("pdf")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="pdfFileType"
                            >
                              Pdf File
                            </label>
                          </div>
                          <Button
                            className="small outline"
                            type="button"
                            isLoading={isExportFileLoading}
                            disabled={isExportFileLoading}
                            onClick={() => {
                              handleExportReport();
                            }}
                            buttonTitle={
                              isExportFileLoading ? "Exporting..." : "Export"
                            }
                          ></Button>
                          <Button
                            className="error small outline"
                            disabled={isExportFileLoading}
                            type="button"
                            title="Close"
                            onClick={() => {
                              setFileType("pdf");
                              setSelectFileType(!selectFileType);
                            }}
                          >
                            <i className="bi bi-x-lg"></i>
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </form>

        {loading ? (
          <SectionLoader />
        ) : (
          <>
            {" "}
            {paymentList && paymentList.length ? (
              <>
                {showPaymentSummary ? (
                  <>
                    <span className="payment-item mb-2">
                      {showTodaysPayments ? (
                        <span>Today's Earning</span>
                      ) : (
                        <>
                          {(userRole === ROLE_FRONT_DESK_ADMIN ||
                            userRole === ROLE_ASSISTANT) &&
                          !isPaymentAccessAllowed
                            ? "Today's Earning "
                            : "Total Earning "}
                        </>
                      )}
                    </span>
                    <div className="payment-summary mb-4  d-flex flex-wrap">
                      <div className="payment-item txt-success ">
                        Total: Rs.{" "}
                        {isNaN(parseFloat(total).toFixed(2))
                          ? "-"
                          : parseFloat(total).toFixed(2)}
                      </div>
                      <div className="payment-item txt-success ">
                        Cash: Rs.{" "}
                        {isNaN(parseFloat(totalCashPayment).toFixed(2))
                          ? "-"
                          : parseFloat(totalCashPayment).toFixed(2)}
                      </div>
                      <div className="payment-item txt-success ">
                        UPI: Rs.{" "}
                        {isNaN(parseFloat(totalUPIPayment).toFixed(2))
                          ? "-"
                          : parseFloat(totalUPIPayment).toFixed(2)}
                      </div>
                      <div className="payment-item txt-success ">
                        Other: Rs.{" "}
                        {isNaN(
                          parseFloat(totalOtherPaymentMethodsPayment).toFixed(
                            2,
                          ),
                        )
                          ? "-"
                          : parseFloat(totalOtherPaymentMethodsPayment).toFixed(
                              2,
                            )}
                      </div>
                      <div className="payment-item txt-success">
                        Credit Wallet Used: Rs.{" "}
                        {isNaN(parseFloat(totalCreditWalletPayment).toFixed(2))
                          ? "-"
                          : parseFloat(totalCreditWalletPayment).toFixed(2)}
                        <small
                          style={{
                            display: "block",
                            fontSize: "11px",
                            color: "#185FA5",
                            backgroundColor: "#E6F1FB",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            marginTop: "4px",
                            width: "fit-content",
                          }}
                        >
                           Pre-collected · excluded from total
                        </small>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <span className="payment-item mb-2">
                      {showTodaysPayments ? (
                        <span>Today's Earning</span>
                      ) : (
                        <>
                          {(userRole === ROLE_FRONT_DESK_ADMIN ||
                            userRole === ROLE_ASSISTANT) &&
                          !isPaymentAccessAllowed
                            ? "Today's Earning "
                            : ""}
                        </>
                      )}
                    </span>
                    <div className="payment-summary mb-4 ">
                      <div className="payment-item txt-success ">
                        Total: Rs.{" "}
                        {isNaN(parseFloat(total).toFixed(2))
                          ? "-"
                          : parseFloat(total).toFixed(2)}
                      </div>
                    </div>
                  </>
                )}

                <TableContainer id="tableDiv">
                  <Table className="tableX" aria-labelledby="tableTitle">
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={10}
                      headCells={headCells}
                    />
                    <TableBody className="table">
                      {stableSort(
                        paymentList,
                        getComparator(order, orderBy),
                      ).map((row) => {
                        return (
                          <TableRow hover tabIndex={-1} key={row.id}>
                            <TableCell data-cell={headCells[0].label}>
                              {row.invoiceNumber}
                            </TableCell>
                            <TableCell
                              className="text-capitalize"
                              data-cell={headCells[1].label}
                            >
                              {row.clientName}
                              {row.isHomeVisit && (
                                <span
                                  style={{
                                    backgroundColor: "transparent",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <i className="bi bi-house-door"></i>
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              data-cell={headCells[2].label}
                              className="text-capitalize"
                            >
                              {row.paymentType}
                            </TableCell>
                            <TableCell data-cell={headCells[3].label}>
                              {convertDateAndTimeToString(row.paymentDate)}
                            </TableCell>
                            <TableCell
                              data-cell={headCells[4].label}
                              align="right"
                            >
                              {parseFloat(row.amount).toFixed(2)}
                            </TableCell>
                            <TableCell
                              data-cell={headCells[5].label}
                              className="txt-success   bg-transparent text-capitalize"
                            >
                              {row.status === "Done" ? <>Paid</> : null}
                            </TableCell>
                            <TableCell data-cell={headCells[6].label}>
                              <div className="p-0 bg-transparent d-flex gap-2 flex-wrap">
                                <Button
                                  className="success outline small"
                                  data-bs-toggle="tooltip"
                                  title="Download/View"
                                  onClick={() => {
                                    setShowInvoiceInstructionModal(
                                      !showInvoiceInstructionModal,
                                    );
                                    setPaymentToDownload(row);
                                  }}
                                >
                                  <i className="bi bi-file-earmark-arrow-down "></i>
                                </Button>
                                <Button
                                  className="error outline small"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                  type="Delete"
                                  onClick={() =>
                                    deletePaymentByIdHandler(row.id)
                                  }
                                >
                                  <i className="bi bi-trash3" />
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  className="table-pagination"
                  rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                  component="div"
                  count={totalPaymentCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  showLastButton={true}
                  showFirstButton={true}
                />
              </>
            ) : (
              <p className="text-center">
                {searchData
                  ? searchResult(searchData)
                  : SEARCH_RESULT_FOR_PAYMENTS}
              </p>
            )}
          </>
        )}

        <SelectInstructionModal
          show={showInvoiceInstructionModal}
          onHide={toggleInvoiceInstructionModal}
          paymentToDownload={paymentToDownload}
        />
      </>
    </div>
  );
}
